import React, { useEffect, useState } from 'react'
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import { Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, Checkbox, TableSortLabel } from '@mui/material';
import SettingNav from '../../../elements/SettingNav';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import { DeletePopUp, NoRecordFound, PageLoader, Pagination, STableLoader } from '../../../../shared_elements';
import WorkingGroupList from '../components/WorkingGroupList';
import { globalDeleteService, globalGetService } from '../../../../utils/globalApiServices';
import { deleteWorkingGroupApi, getWorkingGroupApi } from '../apiService';
import { checkApiStatus } from '../../../../utils';
import WorkingGroupsCRU from '../components/WorkingGroupsCRU';
import { enqueueSnackbar } from 'notistack';
import { ButtonLoader } from '../../../../shared_elements/components';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import { trackActivity } from "../../../../utils/mixpanel";
import { PermissionWrapper } from '../../../../wrappers';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const WorkingGroupHD = ({ createSortHandler, sortInfo, item, bulk, toggleBulkOps }) => {
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Clause`, page_type: page_type });
  }

  const tableSorting = (key, name) => {
    return (
      <TableSortLabel
        active={sortInfo.sort_by === key ? true : false}
        direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
        onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`); }}
      > {name} </TableSortLabel>
    )

  }
  return (
    <TableHead>
      <TableRow>
        <TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap" }}>
          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['D'] }}>
            <Checkbox color="primary" size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
          </PermissionWrapper>
          Action(s)
        </TableCell>
        <TableCell sx={{ width: "200px", whiteSpace: "nowrap" }}>{tableSorting('name', 'Name')}</TableCell>
        <TableCell sx={{ minWidth: "200px", whiteSpace: "nowrap" }}>{tableSorting('remarks', 'Remarks')}</TableCell>
      </TableRow>
    </TableHead>
  )
}

const WorkingGroup = () => {
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [workingGroupInfo, setWorkingGroupInfo] = useState({ list: [], pagination: {} });
  const [workingGroupCUR, setWorkingGroupCUR] = useState({ modal: false, data: null, mode: '' });
  const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
  const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' });
  const [deleteWrg, setDeleteWrg] = useState({ modal: false, data: null });
  const [isExport, setIsExport] = useState(false);
  const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });

  useEffect(() => {
    getWorkingGroupData('skeletonLoader', { per_page: 50 });
    trackActivity('Page Viewed', { page_title: 'Settings Working Group' });
  }, []);

  const getWorkingGroupData = (loaderType, query = {}) => {
    loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
    globalGetService(getWorkingGroupApi(query))
      .then(response => {
        if (checkApiStatus(response)) {
          setWorkingGroupInfo(response.data.data);
        }
        loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
      })
  }

  const deleteWorkingGroup = () => {
    setLoading(true);
    const idsToDelete = deleteWrg?.modal && deleteWrg?.data?.id ? [deleteWrg?.data?.id] : (bulk?.ids || []).map(item => item?.id);
    globalDeleteService(deleteWorkingGroupApi(), { ids: idsToDelete })
      .then(response => {
        if (checkApiStatus(response)) {
          setDeleteWrg({ modal: false, data: null });
          getWorkingGroupData('', { per_page: workingGroupInfo?.pagination?.per_page });
          setBulk({ modal: false, ids: [], title: '', type: '' })
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Deleted', { page_title: `Delete Working Group`, success_msg: response?.data?.message, item_ids: deleteWrg?.data || bulk?.ids, response: response?.data })
        } else {
          setLoading(false);
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Deleted', { page_title: `Delete Working Group`, error_msg: response?.data?.message, item_ids: deleteWrg?.data || bulk?.ids, response: response?.data })
        }
      })
  }

  const createSortHandler = (key) => {
    let sortQuery = { sort_by: key };
    if (sortInfo.sort_by === key) {
      sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
    } else {
      sortQuery = { ...sortQuery, sort: 'asc' }
    }
    setSortInfo(sortQuery)
    getWorkingGroupData('pageLoader', { ...sortQuery, per_page: workingGroupInfo?.pagination?.per_page });
  }

  const toggleBulkOps = (flag, type, item) => {
    if (type === 'bulk') {
      setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
    } else {
      setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
    }
  }

  const handleExport = () => {
    let query = { export: true }
    if (sortInfo?.sort && sortInfo?.sort_by) {
      query = { ...query, sort: sortInfo?.sort, sort_by: sortInfo?.sort_by }
    }
    setIsExport(true);
    globalGetService(getWorkingGroupApi(query)).then((response) => {
      if (checkApiStatus(response)) {
        enqueueSnackbar(response?.data.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
      }
      setIsExport(false);
    })
  }

  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Settings Working Group`, page_type: page_type, })
  }

  return (
    <Paper className="setting_details_section lease-details-section lease-module-paper" elevation={0}>
      <SettingNav />
      <div className="lease-details-content" >
        <Paper square className="responsive-paper">
          <Grid container spacing={1} className="responsive-grid" alignItems='flex-end'>
            <Grid item size={{ md: 4, xs: 12 }} className="menu-container">
              <BackToLeaseList />
            </Grid>
            <Grid item size={{ md: 8, xs: 12 }}>
              <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '5px 0px' }}>
                <li className='lease-mobile-button revision-history'>
                  <ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: "", type: "global" } })} />
                </li>
                {bulk?.type && bulk?.ids?.length ? <>
                  <li className='lease-mobile-button'>
                    <Button size="small" variant="outlined" color="primary" onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }}>Cancel</Button>
                  </li>
                  <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['D'] }}>
                    <li className='lease-mobile-button'>
                      <Button variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }} onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }}>{`Delete (${bulk?.ids?.length})`}</Button>
                    </li>
                  </PermissionWrapper>
                </> : null}
                {workingGroupInfo?.list?.length > 0 ?
                  <li className='lease-mobile-button'>
                    <Button className='btn-primary action-btn-start-icon' variant="outlined" size='small' startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }}> Export </Button>
                  </li> : null}
                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['C'] }}>
                  <li className='lease-mobile-button'> <Button variant="contained" color="primary" size='small' startIcon={<AddOutlinedIcon />} className='btn-primary action-btn-start-icon' onClick={() => { setWorkingGroupCUR({ modal: true, data: null, mode: 'add' }); handleItemClicked('Add Item Button') }}> Add Working Group </Button> </li>
                </PermissionWrapper>
              </ul>
            </Grid>
          </Grid>
        </Paper>
        <Paper className="lease-detail-table table-container lease-module-paper" elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(100vh - 138px)', height: workingGroupInfo?.list?.length > 0 ? 'calc(100vh - 138px) !important' : 'auto !important' }}>
          <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
            {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
              <Table className='mui-table-format' stickyHeader>
                <WorkingGroupHD
                  item={workingGroupInfo?.list}
                  bulk={bulk}
                  toggleBulkOps={toggleBulkOps}
                  sortInfo={sortInfo}
                  createSortHandler={createSortHandler} />
                <TableBody>
                  {workingGroupInfo?.list?.length > 0 && workingGroupInfo?.list?.map((item, index) =>
                    <WorkingGroupList
                      key={index}
                      item={item}
                      bulk={bulk}
                      toggleBulkOps={toggleBulkOps}
                      onEditFn={() => setWorkingGroupCUR({ modal: true, data: item, mode: 'edit' })}
                      onView={() => setWorkingGroupCUR({ modal: true, data: item, mode: 'view' })}
                      onDelete={() => { setDeleteWrg({ modal: true, data: item, }); setBulk({ modal: false, ids: [item], title: '', type: '' }); }}
                      viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                    />)}
                </TableBody>
              </Table>
            )}
            {!skeletonLoader && workingGroupInfo?.list?.length === 0 && <NoRecordFound />}
          </div>
          <Paper square>
            <Pagination
              pagination={workingGroupInfo?.pagination}
              onPageChange={(event, newPage) => { const pageNum = newPage + 1; getWorkingGroupData('pageLoader', { page: pageNum, per_page: workingGroupInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}) }); }}
              onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getWorkingGroupData('pageLoader', { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}) }); }}
            />
          </Paper>
        </Paper>
      </div>
      {workingGroupCUR.modal && <WorkingGroupsCRU
        workingGroupCUR={workingGroupCUR}
        modeType={workingGroupCUR?.mode}
        getResponseBack={() => {getWorkingGroupData("", { per_page: workingGroupInfo?.pagination?.per_page }); setBulk({ modal: false, ids: [], title: '',type: '' })}}
        onToggleModal={() => setWorkingGroupCUR({ modal: false, data: null, mode: '' })} />}

      {deleteWrg.modal || bulk.modal ?
        <DeletePopUp
          modal={bulk.modal ? bulk.modal : deleteWrg.modal}
          title={bulk?.modal ? (bulk?.ids?.length > 0 && bulk?.ids?.length === (workingGroupInfo?.list?.length || 0)) ? "Delete All Working Group" : "Delete Selected Working Group" : "Delete Working Group"}
          content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
          onToggleModal={() => bulk.modal ? setBulk({ modal: false, ids: [], title: '', type: '' }) : (setDeleteWrg({ modal: false, data: null }), setBulk({ modal: false, ids: [], title: '', type: '' }))}
          onDeleteRecords={() => deleteWorkingGroup()}
        /> : null}

      {
        revisionHistory.modal &&
        <RevisionHistory
          moduleName={"settings_working_group"}
          revisionHistory={revisionHistory}
          onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
        />
      }
      {loading ? <PageLoader /> : null}
    </Paper>
  )
}
export default WorkingGroup;